// tslint:disable
/* MACLE TypeScript 31/07/2026 23:43:12 */
import { ConsumidorSiteResponseGetConsumidorV1APP, ConsumidorSiteResponseChaveConfirmacaoValida, DataConsultaParcelaAPP, PKDependenteAPP, ConsClienteAPP, PKDocVendaAPP, DataDocVendaAPP, DataNovoClienteAPP, ETipoConfirmacaoConsumidorSiteAPP, PKParcelaAPP, DataRespCanSelect, ConsumidorSiteResponseGetConsumidorV0APP, DataCepAPP } from '../vo/sitevo.vo';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService, AjaxService, IModelServiceResponse, Parser, ArrayList } from 'maf-web';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ConsumidorSiteClientModelService extends BaseService {
  private _url = 'consumidorsiteclientService?action=';

  constructor(router: Router, ajax: AjaxService, private toastrService: ToastrService) {
    super(router, ajax, toastrService);
  }

  public getConsumidor(CPF: string): Promise<ConsumidorSiteResponseGetConsumidorV1APP> {
    let params = {
      "CPF": CPF
    };
    return this.ajax.post(this._url + 'getConsumidor', params)
      .then((r: IModelServiceResponse<ConsumidorSiteResponseGetConsumidorV1APP>) => Parser.jsonToClass(r.value, ConsumidorSiteResponseGetConsumidorV1APP))
      .catch((error: any) => this.handleError(error));
  }

  public isTokenValido(token: string): Promise<ConsumidorSiteResponseChaveConfirmacaoValida> {
    let params = {
      "token": token
    };
    return this.ajax.post(this._url + 'isTokenValido', params)
      .then((r: IModelServiceResponse<ConsumidorSiteResponseChaveConfirmacaoValida>) => Parser.jsonToClass(r.value, ConsumidorSiteResponseChaveConfirmacaoValida))
      .catch((error: any) => this.handleError(error));
  }

  public getParcelasCliente(token: string): Promise<DataConsultaParcelaAPP> {
    let params = {
      "token": token
    };
    return this.ajax.post(this._url + 'getParcelasCliente', params)
      .then((r: IModelServiceResponse<DataConsultaParcelaAPP>) => Parser.jsonToClass(r.value, DataConsultaParcelaAPP))
      .catch((error: any) => this.handleError(error));
  }

  public getDadosCliente(pk: PKDependenteAPP): Promise<ConsClienteAPP> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'getDadosCliente', params)
      .then((r: IModelServiceResponse<ConsClienteAPP>) => Parser.jsonToClass(r.value, ConsClienteAPP))
      .catch((error: any) => this.handleError(error));
  }

  public verificaCPF(CPF: string): Promise<boolean> {
    let params = {
      "CPF": CPF
    };
    return this.ajax.post(this._url + 'verificaCPF', params)
      .then((r: IModelServiceResponse<boolean>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public getDocVenda(pkDocVenda: PKDocVendaAPP): Promise<DataDocVendaAPP> {
    let params = {
      "pkDocVenda": pkDocVenda
    };
    return this.ajax.post(this._url + 'getDocVenda', params)
      .then((r: IModelServiceResponse<DataDocVendaAPP>) => Parser.jsonToClass(r.value, DataDocVendaAPP))
      .catch((error: any) => this.handleError(error));
  }

  public verificaTelefone(telefone: string): Promise<boolean> {
    let params = {
      "telefone": telefone
    };
    return this.ajax.post(this._url + 'verificaTelefone', params)
      .then((r: IModelServiceResponse<boolean>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public salvarNovoCliente(cliente: DataNovoClienteAPP): Promise<boolean> {
    let params = {
      "cliente": cliente
    };
    return this.ajax.post(this._url + 'salvarNovoCliente', params)
      .then((r: IModelServiceResponse<boolean>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public isChaveConfirmacaoValida(CPF: string, chaveConfirmacao: number): Promise<ConsumidorSiteResponseChaveConfirmacaoValida> {
    let params = {
      "CPF": CPF,
      "chaveConfirmacao": chaveConfirmacao
    };
    return this.ajax.post(this._url + 'isChaveConfirmacaoValida', params)
      .then((r: IModelServiceResponse<ConsumidorSiteResponseChaveConfirmacaoValida>) => Parser.jsonToClass(r.value, ConsumidorSiteResponseChaveConfirmacaoValida))
      .catch((error: any) => this.handleError(error));
  }

  public confirmacaoValidaByCliente(pk: PKDependenteAPP, tipoConfirmacao: ETipoConfirmacaoConsumidorSiteAPP, chaveConfirmacao: number): Promise<ConsClienteAPP> {
    let params = {
      "pk": pk,
      "tipoConfirmacao": tipoConfirmacao,
      "chaveConfirmacao": chaveConfirmacao
    };
    return this.ajax.post(this._url + 'confirmacaoValidaByCliente', params)
      .then((r: IModelServiceResponse<ConsClienteAPP>) => Parser.jsonToClass(r.value, ConsClienteAPP))
      .catch((error: any) => this.handleError(error));
  }

  public podeSelicionarParcApp(parcela: PKParcelaAPP, marcadas: PKParcelaAPP[]): Promise<DataRespCanSelect> {
    let params = {
      "parcela": parcela,
      "marcadas": marcadas
    };
    return this.ajax.post(this._url + 'podeSelicionarParcApp', params)
      .then((r: IModelServiceResponse<DataRespCanSelect>) => Parser.jsonToClass(r.value, DataRespCanSelect))
      .catch((error: any) => this.handleError(error));
  }

  public envioConfirmacaoDados(pk: PKDependenteAPP): Promise<ConsumidorSiteResponseGetConsumidorV0APP> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'envioConfirmacaoDados', params)
      .then((r: IModelServiceResponse<ConsumidorSiteResponseGetConsumidorV0APP>) => Parser.jsonToClass(r.value, ConsumidorSiteResponseGetConsumidorV0APP))
      .catch((error: any) => this.handleError(error));
  }

  public buscaCEP(cep: string): Promise<DataCepAPP> {
    let params = {
      "cep": cep
    };
    return this.ajax.post(this._url + 'buscaCEP', params)
      .then((r: IModelServiceResponse<DataCepAPP>) => Parser.jsonToClass(r.value, DataCepAPP))
      .catch((error: any) => this.handleError(error));
  }

}


